export const garantieFinanciereKeys = {
  all: ["garantie-financiere"] as const,
  admin: (siren: string, millesime: number, categorie: string) =>
    [
      ...garantieFinanciereKeys.all,
      "admin",
      siren,
      millesime,
      categorie,
    ] as const,
};
